import React from 'react'
import { Table } from 'react-bootstrap'
import ReactMarkdown from 'react-markdown'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { getNotification, makeReadNotification, makeUnreadNotification } from '../actions/notifications'
import { formatTimeString } from '../utils/formatters'

const NotificationComponent = ({ data, makeReadNotification, makeUnreadNotification, getNotification }) => {
  const { message, state, id } = data

  return (
    <div className='ibox float-e-margins animated fadeIn section-shadow'>
      <div className='ibox-title round-corner-box-top'>
        <h5>
          Notification ID:
          {data.id}
        </h5>
      </div>
      <div className='ibox-content table-responsive round-corner-box-bottom'>
        <Table striped bordered hover>
          <tbody>
            <tr>
              <th style={{ width: '25%' }}>Type</th>
              <td>{message.message_type ? message.message_type.name : ''}</td>
            </tr>
            <tr>
              <th style={{ width: '25%' }}>Importance</th>
              <td>{message.message_importance ? message.message_importance.name : ''}</td>
            </tr>
            <tr>
              <th style={{ width: '25%' }}>Subject</th>
              <td>{message.subject}</td>
            </tr>
            <tr>
              <th style={{ width: '25%' }}>Body</th>
              <td>
                <ReactMarkdown source={message.body} />
              </td>
            </tr>
            <tr>
              <th style={{ width: '25%' }}>Created</th>
              <td>{formatTimeString(data.created)}</td>
            </tr>
            <tr>
              <th style={{ width: '25%' }}>Read</th>
              <td>{data.date_read ? formatTimeString(data.date_read) : ''}</td>
            </tr>
          </tbody>
        </Table>
        <div className='row' style={{ textAlign: 'right' }}>
          <div className='col-md-12'>
            <button
              disabled={state !== 'read'}
              type='button'
              className='btn btn-default'
              onClick={async () => {
                await makeUnreadNotification(id)
                getNotification(id)
              }}
            >
              Mark As Unread
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => ({})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      makeReadNotification,
      makeUnreadNotification,
      getNotification,
    },
    dispatch
  )
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NotificationComponent))
